import { render } from "./teachStudioList.vue?vue&type=template&id=29759146&scoped=true"
import script from "./teachStudioList.vue?vue&type=script&lang=js"
export * from "./teachStudioList.vue?vue&type=script&lang=js"

import "./teachStudioList.vue?vue&type=style&index=0&id=29759146&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29759146"]])

export default __exports__